// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BarcodeOutlinedSvg from "@fishx/icons-svg/es/asn/BarcodeOutlined";
import FishxIcon from '../components/FishxIcon';

var BarcodeOutlined = function BarcodeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BarcodeOutlinedSvg
  }));
};

BarcodeOutlined.displayName = 'BarcodeOutlined';
export default React.forwardRef(BarcodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BarcodeOutlined.js
// module id = 2060
// module chunks = 0